import { render, staticRenderFns } from "./address-modal.vue?vue&type=template&id=515d109c&"
import script from "./address-modal.vue?vue&type=script&lang=ts&"
export * from "./address-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports